import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudEntity} from '@/libs/core/crud/crud-service';

export class CrudPageInfo {
    currentPage = 1;
    rowCount = 0;
    pageSize = 0;
    pageCount = 0;
}

export interface LatestRequestIds {
    data: Dictionary<string>,
    detail: Dictionary<string>,
    sum: Dictionary<string>,
    groupedData: Dictionary<string>
}

export interface CrudStoreState<T extends CrudEntity, TDetail extends CrudEntity> {
    pending: Dictionary<boolean>,
    saving: Dictionary<boolean>,
    deleting: Dictionary<boolean>,
    dataQuery: Dictionary<CrudDataQuery<T>>,
    data: Dictionary<T[]>,
    detail: Dictionary<TDetail | null>,
    pageInfo: Dictionary<CrudPageInfo>,
    sum: Dictionary<number | null>,
    groupedData: Dictionary<any[]>,
    latestRequestIds: LatestRequestIds,
}

export function createCrudStoreState<T extends CrudEntity, TDetail extends CrudEntity>(): CrudStoreState<T, TDetail> {
    return {
        dataQuery: {},
        data: {
            '': []
        },
        pageInfo: {},
        detail: {},
        pending: {},
        saving: {},
        deleting: {},
        sum: {},
        groupedData: {},
        latestRequestIds: {
            data: {},
            detail: {},
            sum: {},
            groupedData: {}
        },
    };
}
